import { RouteLocationNormalizedGeneric } from "vue-router"

export const beforeMetaTitle = function (to: RouteLocationNormalizedGeneric) {
  const title = <string>to.meta.metaTitle || ""
  if (title) {
    window.document.title = title
  }
}
